export const FETCH_CONTENT_RESPONSE_PRIMARY = "FETCH_CONTENT_RESPONSE_PRIMARY";
export const FETCH_CONTENT_RESPONSE = "FETCH_CONTENT_RESPONSE";
export const FETCH_CONTENT_ERROR = "FETCH_CONTENT_ERROR";
export const BUILD_CONTENT = "BUILD_CONTENT";
export const FETCH_INITIAL_STATE = "FETCH_INITIAL_STATE";



// WEBPACK FOOTER //
// ./src/services/content/types.js